// PageHeader.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { colorText } from '../theme/palette';

const PageHeader = ({
  titulo,
  subtitulo = '',
  className = '',
  style = {}
}) => {
  return <div className={`mb-3 ${className}`} style={style}>
      <Typography variant="h5" component="h1" sx={{
      fontSize: '12px',
      fontWeight: 'bold'
    }}>
        {titulo}
      </Typography>

      {subtitulo && <Typography variant="body2" sx={{
      fontSize: '10px',
      color: colorText,
      marginTop: '4px'
    }}>
          {subtitulo}
        </Typography>}
    </div>;
};

PageHeader.propTypes = {
  titulo: PropTypes.string.isRequired,
  subtitulo: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default PageHeader;